import * as ko from "knockout";
import {IMessageData, ISystem, ISystemRole} from '../../index';
import {global} from "../../appContext";
import {HIERARCHY_ARROW, MAX_RESULTS_PER_PAGE} from "../../constants";
import PromiseRequest from "../../req/PromiseRequest";
import {getRoleName} from "../../util/misc";
import {getSearchSystemParams} from "../../util/request";
import {REQUEST_MESSAGE} from "../../constants/Language";
import {nsTooltip} from "../../util/nsTooltip";
import {getHash} from "../../constants/RouteDefinitions";
import system_role_by_idHtml from './system-role-by-id.html?raw';

export let template = system_role_by_idHtml;

interface IParams {
    system?: ISystem
    role?: ISystemRole
    id: number
    showIcon?: boolean
    requestMessage?: IMessageData
    onLoad: (s: ISystem, r: ISystemRole) => void
    linkable?: boolean
    showSystemName?: boolean
}

export class viewModel {
    private readonly HIERARCHY_ARROW = HIERARCHY_ARROW
    private messageData: KnockoutObservable<IMessageData | null> = ko.observable(null);
    private isReady: KnockoutObservable<boolean | null> = ko.observable(null);
    private req_searchsystem: PromiseRequest = global.getPromiseRequest('searchsystem');
    private data: KnockoutObservable<{ name: {system: string, role: string}, href?: string, icon?: string } | null> = ko.observable(null);
    private system: ISystem | null = null;
    private role: ISystemRole | null = null;

    constructor(private params: IParams) {
        this.system = params.system ?? null
        this.role = params.role ?? null
        if (this.system && this.role) {
            this.onSuccess()
        } else {
            this.init();
        }
    }

    private init() {
        if (!this.params.id) {
            return;
        }
        this.isReady(false);
        this.messageData( this.params.requestMessage ?? {message: REQUEST_MESSAGE});

        this.req_searchsystem
            .request(getSearchSystemParams({
                ...(global.login.selectedOrganizationId() != null ? {orgnr: global.login.selectedOrganizationId()!} : {}),
                resultsprpage: MAX_RESULTS_PER_PAGE,
            }))
            .then((data: ISystem[]) => {
                this.system = data.find(s => s.roles.find(sr => sr.id == this.params.id)) ?? null;
                this.role = this.system?.roles.find(sr => sr.id == this.params.id) ?? null;
                if (this.system && this.role) {
                    this.onSuccess()
                }
                this.messageData(null);
                this.isReady(true);
            })
            .catch((reason: string) => {
                this.messageData({message: "data not available", type: "warning"});
            })
        ;
    }

    private onSuccess() {
        if (!this.system || !this.role) {
            return;
        }
        this.params.onLoad?.(this.system, this.role)
        const href = getHash('systemaccessdetails', {id: this.role.systemid}, true, this.system.companyid) ?? undefined;
        this.data({
            ...(this.params.showIcon ? {icon: 'fa-id-card-alt'} : {}),
            name: {
                system: this.system.name ?? '',
                role: getRoleName(this.system, this.role) ?? '',
            },
            ...(href !== undefined ? {href} : {}),
        });
    }

    private getTitle(): string {
        if (!this.system || !this.role) {
            return '';
        }
        return nsTooltip.getTitle_role(this.system, this.role) ?? ''
    }

    private onRoleClicked() {
        return true
    }

    dispose() {
        this.req_searchsystem.abort();
    }
}
